import { useNavigate } from "react-router-dom";

/**
 * useProfileNavigation
 * 
 * Responsabilidade única: navegação a partir do perfil do membro.
 * Monta o state necessário e redireciona para as rotas corretas.
 * 
 * @param {Object} member - Dados do membro para montar o state de navegação
 */
const useProfileNavigation = (member) => {
    const navigate = useNavigate();

    /** Monta o objeto de state padrão do membro para navegação */
    const buildMemberState = () => {
        if (!member) return {};
        return {
            id: member.id,
            idMember: member.memberNumber,
            memberName: member.fullName,
            memberPhone: member.phone,
            memberEmail: member.email,
            memberPhotoUrl: member.photoUrl,

            idConsultant: member.consultant?.uid || member.idConsultant,
            consultantName: member.consultant?.name || member.consultantName,
            consultantEmail: member.consultant?.email,
            consultantPhone: member.consultant?.phone,
            consultantPhotoUrl: member.consultant?.photoUrl,
        };
    };

    const handleNewSale = () => {
        if (!member) return;
        navigate(`/members/${member.id}/sales-point`, { state: buildMemberState() });
    };

    const handlePayDebt = () => {
        if (!member) return;
        navigate(`/members/${member.id}/debt-payment`, { state: buildMemberState() });
    };

    const handleNewEnrollment = () => {
        if (!member) return;
        const mode = member.status === "inactive" || member.status === "lead" ? "trial" : "regular";
        navigate(`/grade/enrollment?idMember=${member.id}&memberName=${encodeURIComponent(member.fullName)}&mode=${mode}`);
    };

    return {
        handleNewSale,
        handlePayDebt,
        handleNewEnrollment,
    };
};

export default useProfileNavigation;
